import { useState } from 'react';
import { LAYER_CONFIG } from './mapConstants';

export const LayerPanel = ({
  layerStates,
  onToggle,
  buildingCheck,
  onBuildingToggle,
  heatmapCheck,
  onHeatmapToggle,
}) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleRow = (opts) => {
    const { id, label, checked, onClick, swatch } = opts;
    return (
      <label
        key={id}
        htmlFor={id}
        style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '7px 4px', cursor: 'pointer', borderRadius: 6,
          userSelect: 'none', transition: 'background 0.12s',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = '#f1f5f9')}
        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
      >
        <input
          id={id}
          type="checkbox"
          checked={!!checked}
          onChange={onClick}
          style={{ cursor: 'pointer', accentColor: '#0891b2', width: 15, height: 15 }}
        />
        {swatch}
        <span style={{ fontSize: 13, color: '#1e293b', fontWeight: 500 }}>{label}</span>
      </label>
    );
  };

  return (
    <div style={{
      position: 'absolute', top: 12, right: 12, zIndex: 10001,
      background: '#ffffff', borderRadius: 10,
      boxShadow: '0 10px 30px rgba(15,23,42,0.15), 0 2px 6px rgba(15,23,42,0.08)',
      minWidth: 210, maxWidth: 240, pointerEvents: 'auto',
      fontFamily: "'Segoe UI', Roboto, Arial, sans-serif",
      overflow: 'hidden', border: '1px solid #e2e8f0',
    }}>
      <div
        style={{
          cursor: 'pointer', padding: '10px 14px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: 'linear-gradient(135deg, #0c4a6e 0%, #0891b2 100%)',
          color: '#fff',
        }}
        onClick={() => setCollapsed(!collapsed)}
      >
        <span style={{ fontSize: 13, fontWeight: 600, letterSpacing: 0.3, display: 'flex', alignItems: 'center', gap: 8 }}>
          <i className="bi bi-layers-fill" style={{ fontSize: 14 }}></i> Map Layers
        </span>
        <i className={`bi bi-chevron-${collapsed ? 'down' : 'up'}`} style={{ fontSize: 11, opacity: 0.85 }}></i>
      </div>

      {!collapsed && (
        <div style={{ padding: '8px 10px' }}>
          <div style={{ fontSize: 10.5, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8, color: '#64748b', padding: '4px 4px 2px' }}>
            Boundaries
          </div>
          {LAYER_CONFIG.map((layer) => toggleRow({
            id: `layer-${layer.key}`,
            label: layer.label,
            checked: layerStates[layer.key],
            onClick: () => onToggle(layer.key),
            swatch: (
              <span style={{
                width: 14, height: 4, backgroundColor: layer.color,
                borderRadius: 2, flexShrink: 0,
              }}></span>
            ),
          }))}

          <div style={{ borderTop: '1px solid #e2e8f0', margin: '6px 0' }}></div>
          <div style={{ fontSize: 10.5, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8, color: '#64748b', padding: '4px 4px 2px' }}>
            Data
          </div>

          {toggleRow({
            id: 'layer-buildings',
            label: 'Buildings',
            checked: buildingCheck,
            onClick: onBuildingToggle,
            swatch: (
              <span style={{
                width: 14, height: 14,
                background: 'linear-gradient(135deg, #2196F3 0%, #FF9800 50%, #9C27B0 100%)',
                borderRadius: 3, flexShrink: 0,
              }}></span>
            ),
          })}

          {toggleRow({
            id: 'layer-heatmap',
            label: 'Crowding heatmap',
            checked: heatmapCheck,
            onClick: onHeatmapToggle,
            swatch: (
              <span style={{
                width: 14, height: 14,
                background: 'radial-gradient(circle, #dc2626 0%, #f97316 35%, #eab308 60%, #22c55e 85%, transparent 100%)',
                borderRadius: '50%', flexShrink: 0,
              }}></span>
            ),
          })}
        </div>
      )}
    </div>
  );
};
